export const colors: string[] = ['red', 'orange', 'amber', 'green', 'cyan', 'blue', 'purple', 'pink', 'gray'];
